import { useMutation, useQuery } from 'react-query'

import { QueryKey } from '../../../common/api'
import { queryClient } from '../../../common/providers/query'
import { projectApi } from '../api/project.api'
import { CreateProjectDto, Project } from '../types/project.types'

export const useCreateProject = () => {
  return useMutation(
    (project: CreateProjectDto) => {
      return projectApi.create(project)
    },
    {
      onSuccess: () => {
        return queryClient.invalidateQueries(QueryKey.Projects)
      },
    },
  )
}

export const useListProjects = () => {
  return useQuery<Project[]>([QueryKey.Projects], async () => {
    return await projectApi.list()
  })
}
